import React, { useState, useRef, useEffect } from "react"
import useDelayedHeightCalculation from 'shared/hooks/useDelayedHeightCalculation';
import './copyTrading.css';
import './blofin.css'

const CopyBlofin = ({ navbarHeight }) => {

    const section1Ref = useRef(null);
    const section2Ref = useRef(null);
    const section3Ref = useRef(null);
    const button1Ref = useRef(null);
    const [button2Width, setButton2Width] = useState(0);
    const [bgHeight, setBgHeight] = useState(0);

    const section1Height = useDelayedHeightCalculation(section1Ref, 100);

    useEffect(() => {
        setBgHeight(section1Height + navbarHeight)
        if (button1Ref.current) {
            const button1Width = button1Ref.current.offsetWidth
            setButton2Width(button1Width)
        }
    })

    const scrollToSection = (sectionRef) => {
        if (sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="blofin-main-content">

            <div className="copy-section1" ref={section1Ref}>
                <img src='../.././assets/images/backgrounds/bg1.png'
                    className='copy-section1-bg'
                    style={{ height: `${bgHeight}px` }}
                    alt="Background"
                />
                <div className="blofin-copy-section1-header">
                    <h1><span>Copy Trading Access</span> on <span>Blofin</span></h1>
                    <h2 style={{ maxWidth: '70%', textAlign: 'center' }}>Use the current Blofin path to follow CRYPTOXNFT and selected traders with your own risk controls.</h2>
                </div>
                <div className="copy-section1-buttons">
                    <a href="https://blofin.com/invite/CRYPTOXNFT" target="_blank"><button className="button-light" style={{ width: `${button2Width}px` }}>SIGN UP</button></a>
                    <button onClick={() => scrollToSection(section3Ref)} className="button-light" ref={button1Ref}>RESULTS</button>
                </div>
                <div className="copy-section1-horizontal-line"></div>
                <div className="copy-section1-images-main">
                    <div className="copy-section1-images-left">
                        <div className="copy-section1-images-wrapper">
                            <h2>7D PNL: $15,670.33</h2>
                            <img src="../.././assets/images/services/copy/blofin/data2.png" alt="7 day pnl" />
                        </div>
                    </div>
                    <div className="copy-section1-images-right">
                        <div className="copy-section1-images-wrapper">
                            <h2>30D ROI: 597.43%</h2>
                            <img src="../.././assets/images/services/copy/blofin/idk.png" alt="roi" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="copy-section2" ref={section2Ref}>
                <h1>JOIN THROUGH BLOFIN</h1>
                <h2>Follow the verification steps below.</h2>
                <div className="copy-section2-steps">
                    <div className="copy-step">
                        <h2 className="copy-steps-header">STEP 1</h2>
                        <h3>Create a Blofin Account</h3>
                        <p>Only “cryptoxnft” promo code counts!</p>
                        <a href="https://blofin.com/invite/CRYPTOXNFT" target="_blank"><button>CREATE ACCOUNT</button></a>
                    </div>

                    <div className="copy-step">
                        <h2 className="copy-steps-header">STEP 2</h2>
                        <h3>Download Blofin App</h3>
                        <div className="copy-step-images">
                            <a href="https://apps.apple.com/us/app/blofin/id1616804346" target="_blank"><img src="../.././assets/images/services/copy/appstore.png" alt="Download App 1" /></a>
                            <a href="https://play.google.com/store/apps/details?id=com.blofin.android" target="_blank"><img src="../.././assets/images/services/copy/googleplay.png" alt="Download App 2" /></a>
                        </div>
                    </div>

                    <div className="copy-step">
                        <h2 className="copy-steps-header">STEP 3</h2>
                        <h3>Deposit minimum 500$</h3>
                    </div>

                    <div className="copy-step">
                        <h2 className="copy-steps-header">STEP 4</h2>
                        <h3>Join Discord & Open ticket</h3>
                        <a href="https://discord.gg/Kz3udWcnUS" target="_blank"><button>JOIN DISCORD</button></a>
                    </div>
                </div>
                <h1>YOU MUST USE PROMO CODE: <span>CRYPTOXNFT</span></h1>
                <h2>Join our free Telegram group for daily crypto context.</h2>
                <a href="https://t.me/cryptoxnfts" target="_blank"><button>TELEGRAM</button></a>
            </div>

            <div className="copy-section3" ref={section3Ref}>
                <h1>HISTORICAL RESULTS</h1>
                <div className="copy-section3-row">
                    <div className="copy-section3-left">
                        <div className="copy-section3-left-content">
                            <h2>7 DAY PNL: +15,670.33$</h2>
                            <img src="../.././assets/images/services/copy/blofin/data2.png" alt="image" />
                        </div>
                    </div>
                    <div className="copy-section3-right">
                        <div className="copy-section3-right-content">
                            <h2>30D ROI: +597.43%</h2>
                            <img src="../.././assets/images/services/copy/blofin/idk.png" alt="image" />
                        </div>
                    </div>
                </div>

                <div className="copy-section3-row">
                    <div className="copy-section3-left">
                        <div className="copy-section3-left-content">
                            <h2>PnL</h2>
                            <img src="../.././assets/images/services/copy/blofin/pnl_new.png" alt="image" />
                        </div>
                    </div>
                    <div className="copy-section3-right">
                        <div className="copy-section3-right-content">
                            <h2>ROI Graph</h2>
                            <img src="../.././assets/images/services/copy/blofin/roi.png" alt="image" />
                        </div>
                    </div>
                </div>

                <button onClick={() => scrollToSection(section2Ref)}>SIGN UP</button>

                <div className="copy-section3-pnl-main">
                    <div className="blofin-copy-section3-pnl-row">
                        <div className="blofin-copy-section3-pnl-row-images">
                            <img src="../.././assets/images/services/copy/blofin/pnl_1.jpg" alt="image" />
                            <img src="../.././assets/images/services/copy/blofin/pnl_2.jpg" alt="image" />
                        </div>
                    </div>
                    <div className="blofin-copy-section3-pnl-row">
                        <div className="blofin-copy-section3-pnl-row-images">
                            <img src="../.././assets/images/services/copy/blofin/pnl_3.jpg" alt="image" />
                            <img src="../.././assets/images/services/copy/blofin/pnl_4.jpg" alt="image" />
                        </div>
                    </div>

                    <button onClick={() => scrollToSection(section2Ref)}>SIGN UP</button>

                    <img className="lone-image" src="../.././assets/images/services/copy/blofin/idk2.jpg" alt="image" />
                    <video
                        src="../.././assets/images/services/copy/blofin/blofin_traders.MP4"
                        poster="../.././assets/images/services/copy/blofin/profit.png"
                        loop={true}
                        muted={true}
                        autoPlay={true}
                        playsInline={true}
                        webkit-playsinline="true"
                    />
                    <button onClick={() => scrollToSection(section2Ref)}>SIGN UP</button>
                </div>
            </div>

        </div>
    )
}

export default CopyBlofin
